(() => {
  if (window.npProductCardInitialized) return;
  window.npProductCardInitialized = true;

  // Sync Wishlist from localStorage
  const syncWishlist = () => {
    try {
      const savedWishlist = JSON.parse(localStorage.getItem('np_wishlist') || '[]');
      document.querySelectorAll('[data-np-wishlist-id]').forEach(input => {
        if (savedWishlist.includes(input.dataset.npWishlistId)) {
          input.checked = true;
        }
      });
    } catch (e) {}
  };
  syncWishlist();

  document.addEventListener('change', (e) => {
    const wishInput = e.target.closest('[data-np-wishlist-id]');
    if (!wishInput) return;
    const id = wishInput.dataset.npWishlistId;
    let list = JSON.parse(localStorage.getItem('np_wishlist') || '[]');
    if (wishInput.checked) {
      if (!list.includes(id)) list.push(id);
    } else {
      list = list.filter(item => item !== id);
    }
    localStorage.setItem('np_wishlist', JSON.stringify(list));
  });

  // Delegated click handler for quick-add size chips & swatches
  document.addEventListener('click', async (event) => {
    // Mobile Quick-Add Tray Toggle
    const mobileToggle = event.target.closest('[data-np-mobile-sizes-toggle]');
    if (mobileToggle) {
      event.preventDefault();
      const card = mobileToggle.closest('[data-np-product-card]');
      const tray = card ? card.querySelector('[data-np-quick-sizes]') : null;
      if (tray) tray.classList.toggle('is-open');
      return;
    }

    // Close mobile tray
    const closeTray = event.target.closest('[data-np-mobile-sizes-close]');
    if (closeTray) {
      event.preventDefault();
      const tray = closeTray.closest('[data-np-quick-sizes]');
      if (tray) tray.classList.remove('is-open');
      return;
    }

    // Quick-add size chip button
    const sizeBtn = event.target.closest('[data-np-card-quick-add]');
    if (sizeBtn) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = sizeBtn.dataset.npCardQuickAdd;
      if (!variantId || sizeBtn.disabled) return;

      const origText = sizeBtn.textContent;
      sizeBtn.disabled = true;
      sizeBtn.textContent = '…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          sizeBtn.textContent = '✓';
          if (typeof window.openNexsusCartDrawer === 'function') {
            await window.openNexsusCartDrawer();
          }
          setTimeout(() => {
            sizeBtn.textContent = origText;
            sizeBtn.disabled = false;
          }, 1800);
        } else {
          sizeBtn.textContent = origText;
          sizeBtn.disabled = false;
        }
      } catch (e) {
        sizeBtn.textContent = origText;
        sizeBtn.disabled = false;
      }
      return;
    }

    // Swatch click
    const swatch = event.target.closest('[data-np-card-swatch]');
    if (swatch) {
      event.preventDefault();
      event.stopPropagation();
      const card = swatch.closest('[data-np-product-card]');
      if (!card) return;

      card.querySelectorAll('[data-np-card-swatch]').forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      const newImg = swatch.dataset.swatchImg;
      const imgEl = card.querySelector('.np-card__image--primary');
      if (newImg && imgEl) {
        imgEl.src = newImg;
        if (imgEl.srcset) imgEl.srcset = '';
      }

      const colourName = swatch.dataset.colourName;
      const descEl = card.querySelector('.np-card__descriptor');
      if (descEl && colourName) {
        descEl.textContent = colourName;
      }
    }
  });

  // Swatch hover preview
  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest('[data-np-card-swatch]');
    if (!swatch) return;
    const card = swatch.closest('[data-np-product-card]');
    if (!card) return;
    const newImg = swatch.dataset.swatchImg;
    const imgEl = card.querySelector('.np-card__image--primary');
    if (newImg && imgEl && imgEl.dataset.origSrc === undefined) {
      imgEl.dataset.origSrc = imgEl.src;
    }
    if (newImg && imgEl) {
      imgEl.src = newImg;
    }
  });
})();
